import React, { SVGProps } from 'react'

const SvgToolbarFullscreenExit = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 -960 960 960"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'currentColor'}
      d="M240-120v-120H120v-80h200v200h-80Zm400 0v-200h200v80H720v120h-80ZM120-640v-80h120v-120h80v200H120Zm520 0v-200h80v120h120v80H640Z"
    />
  </svg>
)

export default SvgToolbarFullscreenExit
